export default __webpack_public_path__ + "static/media/launch.6a109105.svg";